module.exports = __webpack_public_path__ + "img/Restaurant14.bbd7bc71.png";